import { useTranslation } from '@/app/i18n/client'
import ToggleNews from './ToggleNews'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@/app/globalRedux/store'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import {
  setGuestNewsAbstract,
  setGuestNewsBody,
  setGuestNewsForm,
} from '@/app/globalRedux/guestNewsForm/GuestNewsFormSlice'
import { GuestNewsFormUtils } from '@/app/utils/GuestNewsForm'
import NewsImageUploader from '@/components/NewsImageUploader'
import RichTextEditor from '@/app/[lng]/components/RichTextEditor/RichTextEditor'

const GuestNewsTabs = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const GuestNewsForm = useSelector((state: RootState) => state.GuestNewsForm)
  const validate = new GuestNewsFormUtils(GuestNewsForm, t)
  return (
    <>
      <div className="border-t-2 border-dashed">
        <div className="grid desktop:grid-cols-2 justify-between items-start mt-4 gap-8 mobile:grid-cols-1">
          <ToggleNews
            newsModeValue={GuestNewsForm?.newsMode}
            requestCallBackValue={GuestNewsForm?.requestCallBack}
          />
        </div>
        <div
          className={`transition-all duration-500 ease-in-out overflow-hidden flex flex-col py-2 gap-y-7 text-sm ${
            !GuestNewsForm?.requestCallBack
              ? 'opacity-100  max-h-[2000px] translate-y-0'
              : 'opacity-0 max-h-0 -translate-y-2 pointer-events-none'
          }`}
        >
          <div className="grid desktop:grid-cols-2 justify-between items-start gap-8 mobile:grid-cols-1 transition-all duration-700 ease-in-out">
            <div className="grid w-full items-center gap-3 relative">
              <Label htmlFor="abstract" className="required">
                {t('Title')}
              </Label>
              <Input
                type="text"
                placeholder={t('Enter Title')}
                value={GuestNewsForm?.title ?? ''}
                onChange={(event) => {
                  dispatch(
                    setGuestNewsForm({
                      title: event?.target?.value,
                    })
                  )
                }}
              />
              {validate.validateField('title')?.message}
            </div>
            <div className="grid w-full items-center gap-3 relative">
              <Label className="required" htmlFor="email">
                {t('Email')}
              </Label>
              <Input
                id="email"
                type="text"
                placeholder={t('Enter Email')}
                value={GuestNewsForm?.email ?? ''}
                onChange={(event) => {
                  dispatch(
                    setGuestNewsForm({
                      email: event?.target?.value,
                    })
                  )
                }}
              />

              {validate.validateField('email')?.message}
            </div>
          </div>
          <div className="grid w-full items-center gap-3 relative">
            <Label htmlFor="abstract" className="required">
              {t('Abstract')}
            </Label>
            <RichTextEditor
              toolbarId="toolbar-abstract"
              editorId="editor-abstract"
              type="Abstract"
              value={GuestNewsForm?.caption ?? ''}
              setText={(e: string) => {
                dispatch(setGuestNewsAbstract(e))
              }}
            />
            {validate.validateField('caption')?.message}
          </div>
          <div className="grid w-full items-center gap-3 relative">
            <Label htmlFor="description">{t('Description')}</Label>
            <RichTextEditor
              toolbarId="toolbar-description"
              editorId="editor-description"
              type="Description"
              value={GuestNewsForm?.description ?? ''}
              setText={(e: string) => {
                dispatch(setGuestNewsBody(e))
              }}
            />
          </div>
          <div className="w-full ">
            <div className="w-full gap-3 grid items-center relative">
              <Label htmlFor="picture">{t('Picture')}</Label>
              <NewsImageUploader
                imageArray={GuestNewsForm?.images}
                setImage={(value) => {
                  dispatch(setGuestNewsForm({ images: value }))
                }}
              />

              {validate.validateField('image')?.message}
            </div>
          </div>
        </div>

        <div
          className={`transition-all duration-300 ease-in-out overflow-hidden flex flex-col text-sm mb-4 ${
            GuestNewsForm?.requestCallBack
              ? 'opacity-100 max-h-[500px] translate-y-0'
              : 'opacity-0 max-h-0 -translate-y-2 pointer-events-none'
          }`}
        >
          <div className="grid desktop:grid-cols-2 justify-between items-start gap-8 mobile:grid-cols-1 transition-all duration-700 ease-in-out ">
            <div className="grid w-full items-start gap-3 relative">
              <Label htmlFor="preferred-time" className="required">
                {t('Preferably at this time')}
              </Label>
              <Input
                id={'preferred-time'}
                placeholder={t('Enter Preferred Time')}
                value={GuestNewsForm?.preferredTime}
                onChange={(e) => {
                  dispatch(
                    setGuestNewsForm({
                      preferredTime: e.target.value,
                    })
                  )
                }}
              />
              {validate.validateField('preferredTime').message}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default GuestNewsTabs
